import { Try } from "@/common";
import { IdType, PageDataType } from ".";
import { Notify } from "quasar";
import { api } from "@/plugins";

export type SchemeType = {
  id: number;
  commit: string;
  data: string;
  serviceId: any;
  createdAt: string;
};

export type SchemePartialType = Partial<SchemeType>;
export type SchemePageDataType = PageDataType<SchemeType>;

const url = "scheme";

class SchemeService {
  @Try()
  async page(query: string) {
    const { data } = await api.get<SchemePageDataType>(`/${url}?${query}`);

    return data;
  }

  @Try()
  async getById(id: number) {
    const { data } = await api.get<SchemeType>(`/${url}/${id}`);

    return data;
  }

  @Try()
  async lastCommit(serviceId: number) {
    const { data } = await api.get<SchemeType>(`/${url}/last/${serviceId}`);
    return data;
  }

  @Try()
  async urlHash(hash: string) {
    const { data } = await api.get<SchemeType>(`/${url}/hash/${hash}`);
    return data;
  }

  @Try()
  async search(serviceId: number) {
    const { data } = await api.get<SchemeType[]>(
      `/${url}/search?service_id=${serviceId}`
    );

    return data;
  }

  @Try({
    onSuccess() {
      Notify.create({
        color: "green",
        icon: "tag_faces",
        message: "Commit created successfully",
        position: "top-right",
      });
    },
    onError() {
      Notify.create({
        color: "red",
        icon: "sentiment_very_dissatisfied",
        message: "What went wrong",
        position: "top-right",
      });
    },
  })
  async create(scheme: SchemePartialType) {
    const { data } = await api.post<IdType>(`/${url}/`, scheme);

    return data;
  }

  @Try({
    onSuccess() {
      Notify.create({
        color: "secondary",
        icon: "tag_faces",
        message: "Luck updated",
        position: "top-right",
      });
    },
    onError() {
      Notify.create({
        color: "red",
        icon: "sentiment_very_dissatisfied",
        message: "What went wrong",
        position: "top-right",
      });
    },
  })
  async update(id: number, scheme: SchemePartialType) {
    await api.patch(`/${url}/${id}`, scheme);
    return true;
  }
}

const schemeService = new SchemeService();

export { schemeService as SchemeService };
